import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionId: null,
  mode: null,
  currentIndex: 0,
  answers: {},
  questions: [],
  completed: false,
  score: null,
  results: null,
};

const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    startExam: (state, action) => {
      state.sessionId = action.payload.sessionId;
      state.mode = action.payload.mode;
      state.questions = action.payload.questions;
      state.currentIndex = 0;
      state.answers = {};
      state.completed = false;
      state.score = null;
      state.results = null;
    },
    answerQuestion: (state, action) => {
      const { questionId, selected } = action.payload;
      state.answers[questionId] = selected;
    },
    setCurrentIndex: (state, action) => {
      state.currentIndex = action.payload;
    },
    loadSession: (state, action) => {
      // Generic loader – can be used to restore any saved state
      return { ...state, ...action.payload };
    },
    // NEW: specifically for resuming an incomplete exam
    resumeExam: (state, action) => {
      state.sessionId = action.payload.sessionId;
      state.mode = 'exam'; // resuming always in exam mode
      state.questions = action.payload.questions;
      state.answers = action.payload.answers || {};
      state.currentIndex = action.payload.currentIndex || 0;
      state.completed = false;
      state.score = null;
      state.results = null;
    },
    completeExam: (state, action) => {
      state.completed = true;
      state.score = action.payload.score;
      state.results = action.payload.results;
    },
    clearExam: () => initialState,
  },
});

export const {
  startExam,
  answerQuestion,
  setCurrentIndex,
  loadSession,
  resumeExam,
  completeExam,
  clearExam,
} = examSlice.actions;

export default examSlice.reducer;